import React from "react";
import PerformanceForm from "../components/form";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

// Mock hook to get user data

const SelfEvaluationForm = () => {
  const { grade } = useSelector(selectUser);

  return <PerformanceForm userRole={grade?.name} selfEvaluation={true} />;
};

export default SelfEvaluationForm;
